import { render, staticRenderFns } from "./SellerBidSettings.vue?vue&type=template&id=3227b8f0"
import script from "./SellerBidSettings.vue?vue&type=script&lang=js"
export * from "./SellerBidSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports